import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  sendOTP,
  verifyOTP,
  changePassword,
} from "../../services/AdminServices";
import MenuBar from "../common/MenuPanel";
import FooterPanel from "../common/FooterPanel";
import PhoneInput from "react-phone-number-input";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faKey, faPhone, faLock } from "@fortawesome/free-solid-svg-icons";
import "react-phone-number-input/style.css";
import UtilMethods from "../../util/UtilMethods";
const ForgetPasswordPage = () => {
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState("");
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [otpSent, setOTPSent] = useState(false);
  const [otpVerified, setOTPVerified] = useState(false);

  const showAlert = (message, type, time) => {
    time = time || 5000;
    setAlertMessage(message);
    setAlertType(type);
    setTimeout(() => {
      setAlertMessage("");
      setAlertType("");
    }, time);
  };
  const handleCancelClick = () => {
    navigate(-1); // Navigates back to the previous page
  };
  const handleSendOtp = async () => {
    setLoading(true);
    try {
      const response = await sendOTP(null, phone, null, "forgotPassword");
      showAlert(response.message || "OTP sent to your phone.", "success", 6000);
      setStep(2);
      setOTPSent(true);
    } catch (error) {
      showAlert(error.message || "Failed to send OTP.", "danger");
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOtp = async () => {
    setLoading(true);
    try {
      const response = await verifyOTP(otp, null, phone, "FORGOT_PWD", null);
      if (response.data.status === "approved") {
        showAlert(
          response.message || "OTP verified. Set your new password.",
          "success"
        );
        setStep(3);
        setOTPVerified(true);
      } else {
        showAlert(response.message || "OTP verification failed.", "danger");
      }
    } catch (error) {
      showAlert(error.message || "Invalid OTP.", "danger");
    } finally {
      setLoading(false);
    }
  };

  const handleSetNewPassword = async () => {
    if (!newPassword || !confirmPassword) {
      showAlert("Please enter new password and confirm password.", "danger");
      return;
    }
    const check = UtilMethods.validatePassword(newPassword);
    if (check !== "Y") {
      showAlert(check, "danger");
      return;
    }
    if (newPassword !== confirmPassword) {
      showAlert("Passwords do not match.", "danger");
      return;
    }
    setLoading(true);
    try {
      await changePassword(phone, newPassword);
      showAlert(
        "Password reset successful. Redirecting to login...",
        "success"
      );
      setTimeout(() => navigate("/login"), 3000);
    } catch (error) {
      showAlert(error.message || "Failed to reset password.", "danger");
    } finally {
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <div className="container-fluid position-relative p-0">
        <MenuBar />
      </div>
      <div className="container-fluid p-0">
        <div
          className="banner-image_sm"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/images/2.png)`,
          }}
        >
          <div className="banner-heading text-center wow fadeInDown">
            <h1 className="text-white">Forget Password</h1>
          </div>
        </div>
      </div>

      <div className="container mt-5">
        <div className="col-md-4 col-12 mb-3 mx-auto">
          <form
            onSubmit={(e) => e.preventDefault()}
            className="contact-form mt-4"
          >
            {step === 1 && (
              <>
                {" "}
                <label htmlFor="phone" className="form-label">
                  Enter Registered Phone Number
                </label>
                <div className="input-group">
                  <span className="input-group-text">
                    <FontAwesomeIcon icon={faPhone} />
                  </span>
                  <PhoneInput
                    className="form-control"
                    placeholder="Phone"
                    flagUrl="https://flagcdn.com/w320/{xx}.png"
                    name="phone"
                    defaultCountry="US"
                    disabled={otpVerified} // Disable if OTP is verified
                    value={phone}
                    onChange={(phone) => setPhone(phone)}
                    required
                  />
                </div>
                {errors.phone && (
                  <span className="text-danger">{errors.phone}</span>
                )}
                <div className="d-flex justify-content-between gap-4 mb-3 mt-4">
                  {/* cancel Button */}
                  <button
                    type="cancel"
                    className="btn btn-primary me-2"
                    onClick={handleCancelClick}
                  >
                    {"Cancel"}
                  </button>{" "}
                  <button
                    onClick={handleSendOtp}
                    className="btn btn-primary flex-grow-1"
                    disabled={loading}
                  >
                    {loading ? "Sending OTP..." : "Send OTP"}
                  </button>
                </div>
              </>
            )}

            {step === 2 && (
              <>
                <h3 className="mt-4">Verify OTP</h3>
                <label htmlFor="otp" className="form-label">
                  Enter the OTP sent to your phone
                </label>
                <div className="input-group mb-3">
                  <span className="input-group-text">
                    <FontAwesomeIcon icon={faKey} />
                  </span>
                  <input
                    id="otp"
                    type="text"
                    className="form-control"
                    placeholder="Enter OTP"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                    required
                    autoComplete="one-time-code"
                  />
                </div>
                {/* cancel Button */}
                <button
                  type="cancel"
                  className="btn btn-primary me-2"
                  onClick={handleCancelClick}
                >
                  {"Cancel"}
                </button>
                <button
                  onClick={handleVerifyOtp}
                  className="btn btn-primary flex-grow-1"
                  disabled={loading}
                >
                  {loading ? "Verifying OTP..." : "Verify OTP"}
                </button>
              </>
            )}

            {step === 3 && (
              <>
                <h3 className="mt-4">Set New Password</h3>
                <label htmlFor="new-password" className="form-label">
                  New Password
                </label>
                <div className="input-group mb-3">
                  <span className="input-group-text">
                    <FontAwesomeIcon icon={faLock} />
                  </span>
                  <input
                    id="new-password"
                    type="password"
                    className="form-control"
                    placeholder="Enter new password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    required
                    autoComplete="new-password"
                  />
                </div>
                <label htmlFor="confirm-password" className="form-label">
                  Confirm New Password
                </label>
                <div className="input-group mb-3">
                  <span className="input-group-text">
                    <FontAwesomeIcon icon={faLock} />
                  </span>
                  <input
                    id="confirm-password"
                    type="password"
                    className="form-control"
                    placeholder="Confirm new password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required
                    autoComplete="new-password"
                  />
                </div>
                {/* cancel Button */}
                <button
                  type="cancel"
                  className="btn btn-primary me-2"
                  onClick={handleCancelClick}
                >
                  {"Cancel"}
                </button>
                <button
                  onClick={handleSetNewPassword}
                  className="btn btn-primary flex-grow-1"
                  disabled={loading}
                >
                  {loading ? "Resetting Password..." : "Reset Password"}
                </button>
              </>
            )}
          </form>
        </div>
        {alertMessage && (
          <div className={`alert alert-${alertType} text-center`} role="alert">
            {alertMessage}
          </div>
        )}
      </div>
      <FooterPanel />
    </React.Fragment>
  );
};

export default ForgetPasswordPage;
